import axios from 'axios';
/**
 * 质量监督表列表
 * @param {{id:number,taxNo:String}} params
 * @returns {Promise}
 */
 export const list = (params)=>axios.get('/api/cube-agent/supervise/list',{params})
 /**
  * 需求保存
  * @param {{id:number,taxNo:String}} params
  * @returns {Promise}
  */
  export const save = (data) => axios.post('/api/cube-agent/supervise/save', data)
  /**
   * 首页统计
   * @param {{cycle:String}} params
   */
   export const selectSuperviseCount = (params) => axios.get('/api/cube-agent/supervise/selectSuperviseCount', {params})
